<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Išrašų užsakymas') }}</h1>
    <!-- search -->
    <admin-search-orders-search
      :loading="loading"
      @search="searchInstitutions"
      @downloadReport="downloadReport"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.withdrawal_method`]="{ item }">
        <el-table-enum
          enumName="withdrawalOrder"
          :item="item.withdrawal_method"
        />
      </template>
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="searchOrderStatusList" :item="item.status" />
      </template>
      <template #[`item.type`]="{ item }">
        <el-table-enum enumName="dataVolumeOrderSav" :item="item.type" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            @downloadItem="download(item)"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import AdminSearchOrdersSearch from './AdminSearchOrdersSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import math from '@/mixins/math'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'SearchOrders',
  components: {
    AdminSearchOrdersSearch,
    ModalDelete,
  },
  mixins: [userRole, math, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Išrašo Nr.'),
          align: 'start',
          value: 'number',
        },
        {
          text: this.$t('Gavimo data'),
          align: 'start',
          value: 'receive_date',
        },
        {
          text: this.$t('Užsakovas'),
          align: 'start',
          value: 'user_fullname',
        },
        {
          text: this.$t('Duomenų apimtis'),
          align: 'start',
          value: 'type',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Atsiėmimo būdas'),
          align: 'start',
          value: 'withdrawal_method',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    setItemParam(item) {
      if(item.canEdit){
        item.canIregEdit = true
        item.canEdit = false
      }
      return item
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`statement-orders/list/self-service`, data)
        .then((res) => {
          this.listData = res.data.statementOrders
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    
    searchInstitutions(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },

    editItem(item, mode) {
        this.$router.push({
        name: 'adminOrderForm',
        params: {
          id: item.id,
        },
      })
    },

    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`search-orders/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },

    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`statement-orders/list/self-service`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.statement.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
